var _rect, _rect2, _rect3, _g, _g2, _g3, _path, _path2, _path3, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepositIconTwo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 162,
    viewBox: "0 0 149 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 102,
    y: 128,
    width: 27,
    height: 34,
    rx: 4,
    fill: "url(#paint0_linear_72_2312)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 128,
    width: 27,
    height: 34,
    rx: 4,
    fill: "url(#paint1_linear_72_2312)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 149,
    height: 149,
    rx: 20,
    fill: "url(#paint2_linear_72_2312)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_72_2312)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 128,
    width: 107,
    height: 107,
    rx: 20,
    transform: "rotate(-180 128 128)",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.5,
    y: 127.5,
    width: 106,
    height: 106,
    rx: 19.5,
    transform: "rotate(-180 127.5 127.5)",
    stroke: "url(#paint3_linear_72_2312)",
    strokeOpacity: 0.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_72_2312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 100H120C118.114 100 117.172 100 116.586 99.4142C116 98.8284 116 97.8856 116 96V95C116 93.1144 116 92.1716 116.586 91.5858C117.172 91 118.114 91 120 91H128V100Z",
    fill: "white",
    fillOpacity: 0.3
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_b_72_2312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128 59H120C118.114 59 117.172 59 116.586 58.4142C116 57.8284 116 56.8856 116 55V54C116 52.1144 116 51.1716 116.586 50.5858C117.172 50 118.114 50 120 50H128V59Z",
    fill: "white",
    fillOpacity: 0.3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M100 74.5C100 91.3447 86.3447 105 69.5 105C52.6553 105 39 91.3447 39 74.5C39 57.6553 52.6553 44 69.5 44C86.3447 44 100 57.6553 100 74.5ZM44.6268 74.5C44.6268 88.2371 55.7629 99.3732 69.5 99.3732C83.2371 99.3732 94.3732 88.2371 94.3732 74.5C94.3732 60.7629 83.2371 49.6268 69.5 49.6268C55.7629 49.6268 44.6268 60.7629 44.6268 74.5Z",
    fill: "url(#paint4_linear_72_2312)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M85.053 85.8786L59.2964 60.122C60.8687 56.8307 60.2918 52.7693 57.5657 50.0432C54.1078 46.5854 48.5015 46.5854 45.0437 50.0432C41.5858 53.5011 41.5858 59.1074 45.0437 62.5653C47.7698 65.2913 51.8312 65.8683 55.1224 64.296L80.879 90.0526C79.3068 93.3438 79.8837 97.4053 82.6098 100.131C86.0676 103.589 91.6739 103.589 95.1318 100.131C98.5896 96.6735 98.5896 91.0672 95.1318 87.6093C92.4057 84.8832 88.3443 84.3063 85.053 85.8786Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8795 60.1228L55.123 85.8793C51.8317 84.3071 47.7703 84.884 45.0442 87.6101C41.5864 91.0679 41.5864 96.6742 45.0442 100.132C48.5021 103.59 54.1084 103.59 57.5662 100.132C60.2923 97.406 60.8692 93.3446 59.297 90.0533L85.0536 64.2968C88.3448 65.869 92.4062 65.2921 95.1323 62.566C98.5902 59.1082 98.5902 53.5019 95.1323 50.044C91.6745 46.5861 86.0682 46.5861 82.6103 50.044C79.8842 52.7701 79.3073 56.8315 80.8795 60.1228Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 69,
    cy: 75,
    r: 12,
    fill: "url(#paint5_linear_72_2312)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_72_2312",
    x: -39,
    y: -39,
    width: 227,
    height: 227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_72_2312"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_72_2312",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_72_2312",
    x: 56,
    y: 31,
    width: 132,
    height: 129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_72_2312"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_72_2312",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_b_72_2312",
    x: 56,
    y: -10,
    width: 132,
    height: 129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_72_2312"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_72_2312",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_72_2312",
    x1: 97.5604,
    y1: 124.463,
    x2: 152.98,
    y2: 158.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C42A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738955,
    stopColor: "#2B6EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_72_2312",
    x1: 15.5604,
    y1: 124.463,
    x2: 70.9803,
    y2: 158.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C42A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738955,
    stopColor: "#2B6EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_72_2312",
    x1: -24.5,
    y1: -15.5,
    x2: 239,
    y2: 188.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C42A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B6EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_72_2312",
    x1: 260.5,
    y1: 261,
    x2: 120,
    y2: 104.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_72_2312",
    x1: 34,
    y1: 45.5,
    x2: 123,
    y2: 121.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C42A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B6EFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_72_2312",
    x1: 55.0328,
    y1: 63.5902,
    x2: 90.0492,
    y2: 93.4918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C42A61"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2B6EFE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepositIconTwo);
export default __webpack_public_path__ + "static/media/deposit-icon-two.345b3a2efe4da9fca3a04db4e5d88304.svg";
export { ForwardRef as ReactComponent };